import {
  USER_FRUI_PFXH_MODAL_CHANGE,
} from './constants';

export function frui_pfxhModalChange(visible,type) {
  return {
    type: USER_FRUI_PFXH_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_FRUI_PFXH_MODAL_CHANGE:
      return {
        ...state,
        frui_pfxhModalType:action.data.type,
        frui_pfxhModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/frui_pfxhModalChange.js